import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Card from '@mui/material/Card';

import { useNavigate } from 'react-router-dom';
import Loading from "react-fullscreen-loading";

export default function PayoutsPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(true);

  const [firstName, setFirstName] = React.useState('');
  const [firstNameErrorMessage, setFirstNameErrorMessage] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [lastNameErrorMessage, setLastNameErrorMessage] = React.useState('');
  const [company, setCompany] = React.useState('');
  const [address, setAddress] = React.useState('');
  const [addressErrorMessage, setAddressErrorMessage] = React.useState('');
  const [city, setCity] = React.useState('');
  const [cityErrorMessage, setCityErrorMessage] = React.useState('');
  const [zip, setZip] = React.useState('');
  const [zipErrorMessage, setZipErrorMessage] = React.useState('');
  const [province, setProvince] = React.useState('');
  const [country, setCountry] = React.useState('');
  const [bankingCountry, setBankingCountry] = React.useState('');
  const [bankingCountryOptions, setBankingCountryOptions] = React.useState([]);
  const [payoutOption, setPayoutOption] = React.useState('');
  const [accountHolder, setAccountHolder] = React.useState('');
  const [accountHolderErrorMessage, setAccountHolderErrorMessage] = React.useState('');
  const [bankName, setBankName] = React.useState('');
  const [bankNameErrorMessage, setBankNameErrorMessage] = React.useState('');
  const [bankNumber, setBankNumber] = React.useState('');
  const [bankNumberErrorMessage, setBankNumberErrorMessage] = React.useState('');
  const [accountNumber, setAccountNumber] = React.useState('');
  const [accountNumberErrorMessage, setAccountNumberErrorMessage] = React.useState('');
  const [paypalEmail, setPaypalEmail] = React.useState('');
  const [paypalEmailErrorMessage, setPaypalEmailErrorMessage] = React.useState('');

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const options = {AF:[0,0,0,0], AX:[0,0,0,0], AL:[0,0,0,1], DZ:[0,0,0,1], AS:[0,0,0,0], AD:[0,0,1,1], AO:[0,0,0,1], AI:[0,0,1,1], AQ:[0,0,0,0], AG:[0,0,1,1], AR:[0,0,1,1], AM:[0,0,0,1], AW:[0,0,1,1], AU:[0,0,1,1], AT:[0,1,1,1], AZ:[0,0,0,1], BS:[0,0,1,1], BH:[0,0,1,1], BD:[0,0,0,0], BB:[0,0,0,1], BY:[0,0,0,1], BE:[0,1,1,1], BZ:[0,0,1,1], BJ:[0,0,1,1], BM:[0,0,1,1], BT:[0,0,1,1], BO:[0,0,1,1], BQ:[0,0,0,0], BA:[0,0,0,1], BW:[0,0,1,1], BV:[0,0,0,0], BR:[0,0,1,1], IO:[0,0,0,0], BN:[0,0,1,1], BG:[0,0,1,1], BF:[0,0,0,1], BI:[0,0,0,1], KH:[0,0,0,1], CM:[0,0,1,1], CA:[0,0,1,1], CV:[0,0,1,1], KY:[0,0,1,1], CF:[0,0,0,0], TD:[0,0,0,1], CL:[0,0,1,1], CN:[0,0,1,1], CX:[0,0,0,0], CC:[0,0,0,0], CO:[0,0,0,1], KM:[0,0,1,1], CG:[0,0,0,0], CD:[0,0,0,0], CK:[0,0,1,1], CR:[0,0,1,1], CI:[0,0,0,1], HR:[0,0,1,1], CU:[0,0,0,0], CW:[0,0,0,0], CY:[0,1,1,1], CZ:[0,0,1,1], DK:[0,0,1,1], DJ:[0,0,1,1], DM:[0,0,1,1], DO:[0,0,0,1], EC:[0,0,0,1], EG:[0,0,0,1], SV:[0,0,1,1], GQ:[0,0,0,0], ER:[0,0,0,1], EE:[0,1,1,1], ET:[0,0,0,1], FK:[0,0,1,1], FO:[0,0,1,1], FJ:[0,0,1,1], FI:[0,1,1,1], FR:[0,1,1,1], GF:[0,0,1,1], PF:[0,0,1,1], TF:[0,0,0,0], GA:[0,0,1,1], GM:[0,0,1,1], GE:[0,0,0,1], DE:[0,1,1,1], GH:[0,0,0,0], GI:[0,0,0,0], GR:[0,1,1,1], GL:[0,0,1,1], GD:[0,0,1,1], GP:[0,0,1,1], GU:[0,0,0,0], GT:[0,0,1,1], GG:[0,0,0,0], GN:[0,0,0,1], GW:[0,0,0,1], GY:[0,0,1,1], HT:[0,0,0,0], HM:[0,0,0,0], VA:[0,0,1,1], HN:[0,0,1,1], HK:[0,0,1,1], HU:[0,0,1,1], IS:[0,0,1,1], IN:[0,0,1,1], ID:[0,0,1,1], IR:[0,0,0,0], IQ:[0,0,0,0], IE:[0,1,1,1], IM:[0,0,0,0], IL:[0,0,1,1], IT:[0,1,1,1], JM:[0,0,0,1], JP:[0,0,1,1], JE:[0,0,0,0], JO:[0,0,1,1], KZ:[0,0,0,1], KE:[0,0,1,1], KI:[0,0,1,1], XK:[0,0,0,0], KP:[0,0,0,0], KR:[0,0,1,1], KW:[0,0,1,1], KG:[0,0,0,1], LA:[0,0,1,1], LV:[0,1,1,1], LB:[0,0,0,0], LS:[0,0,1,1], LR:[0,0,0,0], LY:[0,0,0,0], LI:[0,0,1,1], LT:[0,1,1,1], LU:[0,1,1,1], MO:[0,0,0,0], MK:[0,0,0,1], MG:[0,0,1,1], MW:[0,0,1,1], MY:[0,0,1,1], MV:[0,0,1,1], ML:[0,0,0,1], MT:[0,1,1,1], MH:[0,0,1,1], MQ:[0,0,1,1], MR:[0,0,1,1], MU:[0,0,1,1], YT:[0,0,1,1], MX:[0,0,1,1], FM:[0,0,1,1], MD:[0,0,0,1], MC:[0,0,1,1], MN:[0,0,0,1], ME:[0,0,0,1], MS:[0,0,1,1], MA:[0,0,1,1], MZ:[0,0,1,1], MM:[0,0,0,0], NA:[0,0,1,1], NR:[0,0,1,1], NP:[0,0,1,1], NL:[0,1,1,1], AN:[0,0,1,1], NC:[0,0,1,1], NZ:[0,0,1,1], NI:[0,0,0,1], NE:[0,0,0,1], NG:[0,0,0,1], NU:[0,0,1,1], NF:[0,0,1,1], MP:[0,0,0,0], NO:[0,0,1,1], OM:[0,0,1,1], PK:[0,0,0,0], PW:[0,0,1,1], PS:[0,0,0,0], PA:[0,0,0,1], PG:[0,0,1,1], PY:[0,0,1,1], PE:[0,0,1,1], PH:[0,0,1,1], PN:[0,0,1,1], PL:[0,0,1,1], PT:[0,1,1,1], PR:[0,0,0,0], QA:[0,0,1,1], RE:[0,0,1,1], RO:[0,0,1,1], RU:[0,0,0,0], RW:[0,0,0,1], BL:[0,0,0,0], SH:[0,0,1,1], KN:[0,0,0,1], LC:[0,0,1,1], MF:[0,0,0,0], PM:[0,0,1,1], VC:[0,0,1,1], WS:[0,0,1,1], SM:[0,0,1,1], ST:[0,0,1,1], SA:[0,0,0,1], SN:[0,0,0,1], RS:[0,0,1,1], SC:[0,0,1,1], SL:[0,0,0,1], SG:[0,0,1,1], SX:[0,0,0,0], SK:[0,1,1,1], SI:[0,1,1,1], SB:[0,0,1,1], SO:[0,0,0,1], ZA:[0,0,1,1], GS:[0,0,0,0], SS:[0,0,0,0], ES:[0,1,1,1], LK:[0,0,1,1], SD:[0,0,0,0], SR:[0,0,1,1], SJ:[0,0,1,1], SZ:[0,0,1,1], SE:[0,0,1,1], CH:[0,0,1,1], SY:[0,0,0,0], TW:[0,0,1,1], TJ:[0,0,1,1], TZ:[0,0,1,1], TH:[0,0,1,1], TL:[0,0,0,0], TG:[0,0,1,1], TK:[0,0,0,0], TO:[0,0,1,1], TT:[0,0,0,1], TN:[0,0,1,1], TR:[0,0,1,0], TM:[0,0,0,1], TC:[0,0,1,1], TV:[0,0,1,1], UG:[0,0,0,1], UA:[0,0,0,0], AE:[0,0,1,1], GB:[0,0,1,1], US:[1,0,1,1], UM:[0,0,0,0], UY:[0,0,1,1], UZ:[0,0,0,0], VU:[0,0,1,1], VE:[0,0,0,1], VN:[0,0,1,1], VG:[0,0,1,1], VI:[0,0,0,0], WF:[0,0,1,1], EH:[0,0,0,0], YE:[0,0,0,1], ZM:[0,0,1,1], ZW:[0,0,0,1]};

  const handleSelection = (event: SelectChangeEvent) => {
    setPayoutOption(event.target.value);
  };

  function hashCode(str) {
    return str.split('').reduce((prevHash, currVal) =>
      (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
  }

  React.useEffect(() => {
    async function fetchData() {
      if(!(localStorage.getItem("mmEmail") && localStorage.getItem("mmSecret"))) {
        navigate('/login', { replace: true });
      }
      var response = await fetch('https://data.make-money.top/dashboard/i?hash=' + hashCode(localStorage.getItem("mmEmail")), {
        method: 'POST',
        body: JSON.stringify({
          email: localStorage.getItem("mmEmail"),
          secret: localStorage.getItem("mmSecret")
        }),
      });
      if (response.ok) {
        var responseText = await response.json();
        if(responseText.FIRSTNAME) {
          setFirstName(responseText.FIRSTNAME);
        }
        if(responseText.LASTNAME) {
          setLastName(responseText.LASTNAME);
        }
        if(responseText.COMPANY) {
          setCompany(responseText.COMPANY);
        }
        if(responseText.ADDRESS) {
          setAddress(responseText.ADDRESS);
        }
        if(responseText.CITY) {
          setCity(responseText.CITY);
        }
        if(responseText.ZIP) {
          setZip(responseText.ZIP);
        }
        if(responseText.PROVINCE) {
          setProvince(responseText.PROVINCE);
        }
        if(responseText.COUNTRY) {
          setCountry(responseText.COUNTRY);
        }
        if(responseText.BANKINGCOUNTRY) {
          setBankingCountry(responseText.BANKINGCOUNTRY);
          setBankingCountryOptions(options[responseText.BANKINGCOUNTRY]);
        }
        if(responseText.PAYOUTOPTION) {
          setPayoutOption(responseText.PAYOUTOPTION);
        }
        if(responseText.ACCOUNTHOLDER) {
          setAccountHolder(responseText.ACCOUNTHOLDER);
        }
        if(responseText.BANKNAME) {
          setBankName(responseText.BANKNAME);
        }
        if(responseText.BANKNUMBER) {
          setBankNumber(responseText.BANKNUMBER);
        }
        if(responseText.ACCOUNTNUMBER) {
          setAccountNumber(responseText.ACCOUNTNUMBER);
        }
        if(responseText.PAYPALEMAIL) {
          setPaypalEmail(responseText.PAYPALEMAIL);
        }
        setIsLoading(false);
      }
    }
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title> MM Wall | Publisher Dashboard </title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Payouts
        </Typography>
        <Card>
        <Grid container spacing={3} padding={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="firstName"
              name="firstName"
              label="First name"
              fullWidth
              variant="outlined"
              error={firstNameErrorMessage ? true : false}
              helperText={firstNameErrorMessage}
              onChange={(e) => {setFirstName(e.target.value); setFirstNameErrorMessage('');}}
              value={firstName}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="lastName"
              name="lastName"
              label="Last name"
              fullWidth
              variant="outlined"
              error={lastNameErrorMessage ? true : false}
              helperText={lastNameErrorMessage}
              onChange={(e) => {setLastName(e.target.value); setLastNameErrorMessage('');}}
              value={lastName}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled={success}
              id="company"
              name="company"
              label="Company"
              fullWidth
              variant="outlined"
              onChange={(e) => {setCompany(e.target.value);}}
              value={company}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              disabled={success}
              id="address"
              name="address"
              label="Address"
              fullWidth
              variant="outlined"
              error={addressErrorMessage ? true : false}
              helperText={addressErrorMessage}
              onChange={(e) => {setAddress(e.target.value); setAddressErrorMessage('');}}
              value={address}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              required
              disabled={success}
              id="zip"
              name="zip"
              label="Zip / Postal code"
              fullWidth
              variant="outlined"
              error={zipErrorMessage ? true : false}
              helperText={zipErrorMessage}
              onChange={(e) => {setZip(e.target.value); setZipErrorMessage('');}}
              value={zip}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              required
              disabled={success}
              id="city"
              name="city"
              label="City"
              fullWidth
              variant="outlined"
              error={cityErrorMessage ? true : false}
              helperText={cityErrorMessage}
              onChange={(e) => {setCity(e.target.value); setCityErrorMessage('');}}
              value={city}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              disabled={success}
              id="province"
              name="province"
              label="State/Province/Region"
              fullWidth
              variant="outlined"
              onChange={(e) => {setProvince(e.target.value);}}
              value={province}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
            <InputLabel required variant="outlined">Country</InputLabel>
            <Select
              required
              disabled={success}
              id="country"
              name="country"
              label="Country"
              fullWidth
              variant="outlined"
              onChange={(e) => {setCountry(e.target.value); if(!bankingCountry){setBankingCountry(e.target.value); setBankingCountryOptions(options[e.target.value]); setPayoutOption('');}}}
              value={country}
            >
            <MenuItem value={'AF'}>Afghanistan</MenuItem>
            <MenuItem value={'AX'}>Åland Islands</MenuItem>
            <MenuItem value={'AL'}>Albania</MenuItem>
            <MenuItem value={'DZ'}>Algeria</MenuItem>
            <MenuItem value={'AS'}>American Samoa</MenuItem>
            <MenuItem value={'AD'}>Andorra</MenuItem>
            <MenuItem value={'AO'}>Angola</MenuItem>
            <MenuItem value={'AI'}>Anguilla</MenuItem>
            <MenuItem value={'AQ'}>Antarctica</MenuItem>
            <MenuItem value={'AG'}>Antigua and Barbuda</MenuItem>
            <MenuItem value={'AR'}>Argentina</MenuItem>
            <MenuItem value={'AM'}>Armenia</MenuItem>
            <MenuItem value={'AW'}>Aruba</MenuItem>
            <MenuItem value={'AU'}>Australia</MenuItem>
            <MenuItem value={'AT'}>Austria</MenuItem>
            <MenuItem value={'AZ'}>Azerbaijan</MenuItem>
            <MenuItem value={'BS'}>Bahamas</MenuItem>
            <MenuItem value={'BH'}>Bahrain</MenuItem>
            <MenuItem value={'BD'}>Bangladesh</MenuItem>
            <MenuItem value={'BB'}>Barbados</MenuItem>
            <MenuItem value={'BY'}>Belarus</MenuItem>
            <MenuItem value={'BE'}>Belgium</MenuItem>
            <MenuItem value={'BZ'}>Belize</MenuItem>
            <MenuItem value={'BJ'}>Benin</MenuItem>
            <MenuItem value={'BM'}>Bermuda</MenuItem>
            <MenuItem value={'BT'}>Bhutan</MenuItem>
            <MenuItem value={'BO'}>Bolivia</MenuItem>
            <MenuItem value={'BQ'}>Bonaire</MenuItem>
            <MenuItem value={'BA'}>Bosnia and Herzegovina</MenuItem>
            <MenuItem value={'BW'}>Botswana</MenuItem>
            <MenuItem value={'BV'}>Bouvet Island</MenuItem>
            <MenuItem value={'BR'}>Brazil</MenuItem>
            <MenuItem value={'IO'}>British Indian Ocean Territory</MenuItem>
            <MenuItem value={'BN'}>Brunei</MenuItem>
            <MenuItem value={'BG'}>Bulgaria</MenuItem>
            <MenuItem value={'BF'}>Burkina Faso</MenuItem>
            <MenuItem value={'BI'}>Burundi</MenuItem>
            <MenuItem value={'KH'}>Cambodia</MenuItem>
            <MenuItem value={'CM'}>Cameroon</MenuItem>
            <MenuItem value={'CA'}>Canada</MenuItem>
            <MenuItem value={'CV'}>Cape Verde</MenuItem>
            <MenuItem value={'KY'}>Cayman Islands</MenuItem>
            <MenuItem value={'CF'}>Central African Republic</MenuItem>
            <MenuItem value={'TD'}>Chad</MenuItem>
            <MenuItem value={'CL'}>Chile</MenuItem>
            <MenuItem value={'CN'}>China</MenuItem>
            <MenuItem value={'CX'}>Christmas Island</MenuItem>
            <MenuItem value={'CC'}>Cocos Islands</MenuItem>
            <MenuItem value={'CO'}>Colombia</MenuItem>
            <MenuItem value={'KM'}>Comoros</MenuItem>
            <MenuItem value={'CG'}>Republic of the Congo</MenuItem>
            <MenuItem value={'CD'}>Democratic Republic of the Congo</MenuItem>
            <MenuItem value={'CK'}>Cook Islands</MenuItem>
            <MenuItem value={'CR'}>Costa Rica</MenuItem>
            <MenuItem value={'CI'}>Côte d'Ivoire</MenuItem>
            <MenuItem value={'HR'}>Croatia</MenuItem>
            <MenuItem value={'CU'}>Cuba</MenuItem>
            <MenuItem value={'CW'}>Curaçao</MenuItem>
            <MenuItem value={'CY'}>Cyprus</MenuItem>
            <MenuItem value={'CZ'}>Czech Republic</MenuItem>
            <MenuItem value={'DK'}>Denmark</MenuItem>
            <MenuItem value={'DJ'}>Djibouti</MenuItem>
            <MenuItem value={'DM'}>Dominica</MenuItem>
            <MenuItem value={'DO'}>Dominican Republic</MenuItem>
            <MenuItem value={'EC'}>Ecuador</MenuItem>
            <MenuItem value={'EG'}>Egypt</MenuItem>
            <MenuItem value={'SV'}>El Salvador</MenuItem>
            <MenuItem value={'GQ'}>Equatorial Guinea</MenuItem>
            <MenuItem value={'ER'}>Eritrea</MenuItem>
            <MenuItem value={'EE'}>Estonia</MenuItem>
            <MenuItem value={'ET'}>Ethiopia</MenuItem>
            <MenuItem value={'FK'}>Falkland Islands</MenuItem>
            <MenuItem value={'FO'}>Faroe Islands</MenuItem>
            <MenuItem value={'FJ'}>Fiji</MenuItem>
            <MenuItem value={'FI'}>Finland</MenuItem>
            <MenuItem value={'FR'}>France</MenuItem>
            <MenuItem value={'GF'}>French Guiana</MenuItem>
            <MenuItem value={'PF'}>French Polynesia</MenuItem>
            <MenuItem value={'TF'}>French Southern Territories</MenuItem>
            <MenuItem value={'GA'}>Gabon</MenuItem>
            <MenuItem value={'GM'}>Gambia</MenuItem>
            <MenuItem value={'GE'}>Georgia</MenuItem>
            <MenuItem value={'DE'}>Germany</MenuItem>
            <MenuItem value={'GH'}>Ghana</MenuItem>
            <MenuItem value={'GI'}>Gibraltar</MenuItem>
            <MenuItem value={'GR'}>Greece</MenuItem>
            <MenuItem value={'GL'}>Greenland</MenuItem>
            <MenuItem value={'GD'}>Grenada</MenuItem>
            <MenuItem value={'GP'}>Guadeloupe</MenuItem>
            <MenuItem value={'GU'}>Guam</MenuItem>
            <MenuItem value={'GT'}>Guatemala</MenuItem>
            <MenuItem value={'GG'}>Guernsey</MenuItem>
            <MenuItem value={'GN'}>Guinea</MenuItem>
            <MenuItem value={'GW'}>Guinea-Bissau</MenuItem>
            <MenuItem value={'GY'}>Guyana</MenuItem>
            <MenuItem value={'HT'}>Haiti</MenuItem>
            <MenuItem value={'HM'}>Heard Island and McDonald Islands</MenuItem>
            <MenuItem value={'VA'}>Vatican City</MenuItem>
            <MenuItem value={'HN'}>Honduras</MenuItem>
            <MenuItem value={'HK'}>Hong Kong</MenuItem>
            <MenuItem value={'HU'}>Hungary</MenuItem>
            <MenuItem value={'IS'}>Iceland</MenuItem>
            <MenuItem value={'IN'}>India</MenuItem>
            <MenuItem value={'ID'}>Indonesia</MenuItem>
            <MenuItem value={'IR'}>Iran</MenuItem>
            <MenuItem value={'IQ'}>Iraq</MenuItem>
            <MenuItem value={'IE'}>Ireland</MenuItem>
            <MenuItem value={'IM'}>Isle of Man</MenuItem>
            <MenuItem value={'IL'}>Israel</MenuItem>
            <MenuItem value={'IT'}>Italy</MenuItem>
            <MenuItem value={'JM'}>Jamaica</MenuItem>
            <MenuItem value={'JP'}>Japan</MenuItem>
            <MenuItem value={'JE'}>Jersey</MenuItem>
            <MenuItem value={'JO'}>Jordan</MenuItem>
            <MenuItem value={'KZ'}>Kazakhstan</MenuItem>
            <MenuItem value={'KE'}>Kenya</MenuItem>
            <MenuItem value={'KI'}>Kiribati</MenuItem>
            <MenuItem value={'XK'}>Kosovo</MenuItem>
            <MenuItem value={'KP'}>North Korea</MenuItem>
            <MenuItem value={'KR'}>South Korea</MenuItem>
            <MenuItem value={'KW'}>Kuwait</MenuItem>
            <MenuItem value={'KG'}>Kyrgyzstan</MenuItem>
            <MenuItem value={'LA'}>Laos</MenuItem>
            <MenuItem value={'LV'}>Latvia</MenuItem>
            <MenuItem value={'LB'}>Lebanon</MenuItem>
            <MenuItem value={'LS'}>Lesotho</MenuItem>
            <MenuItem value={'LR'}>Liberia</MenuItem>
            <MenuItem value={'LY'}>Libya</MenuItem>
            <MenuItem value={'LI'}>Liechtenstein</MenuItem>
            <MenuItem value={'LT'}>Lithuania</MenuItem>
            <MenuItem value={'LU'}>Luxembourg</MenuItem>
            <MenuItem value={'MO'}>Macao</MenuItem>
            <MenuItem value={'MK'}>Macedonia</MenuItem>
            <MenuItem value={'MG'}>Madagascar</MenuItem>
            <MenuItem value={'MW'}>Malawi</MenuItem>
            <MenuItem value={'MY'}>Malaysia</MenuItem>
            <MenuItem value={'MV'}>Maldives</MenuItem>
            <MenuItem value={'ML'}>Mali</MenuItem>
            <MenuItem value={'MT'}>Malta</MenuItem>
            <MenuItem value={'MH'}>Marshall Islands</MenuItem>
            <MenuItem value={'MQ'}>Martinique</MenuItem>
            <MenuItem value={'MR'}>Mauritania</MenuItem>
            <MenuItem value={'MU'}>Mauritius</MenuItem>
            <MenuItem value={'YT'}>Mayotte</MenuItem>
            <MenuItem value={'MX'}>Mexico</MenuItem>
            <MenuItem value={'FM'}>Micronesia</MenuItem>
            <MenuItem value={'MD'}>Moldova</MenuItem>
            <MenuItem value={'MC'}>Monaco</MenuItem>
            <MenuItem value={'MN'}>Mongolia</MenuItem>
            <MenuItem value={'ME'}>Montenegro</MenuItem>
            <MenuItem value={'MS'}>Montserrat</MenuItem>
            <MenuItem value={'MA'}>Morocco</MenuItem>
            <MenuItem value={'MZ'}>Mozambique</MenuItem>
            <MenuItem value={'MM'}>Myanmar</MenuItem>
            <MenuItem value={'NA'}>Namibia</MenuItem>
            <MenuItem value={'NR'}>Nauru</MenuItem>
            <MenuItem value={'NP'}>Nepal</MenuItem>
            <MenuItem value={'NL'}>Netherlands</MenuItem>
            <MenuItem value={'AN'}>Netherlands Antilles</MenuItem>
            <MenuItem value={'NC'}>New Caledonia</MenuItem>
            <MenuItem value={'NZ'}>New Zealand</MenuItem>
            <MenuItem value={'NI'}>Nicaragua</MenuItem>
            <MenuItem value={'NE'}>Niger</MenuItem>
            <MenuItem value={'NG'}>Nigeria</MenuItem>
            <MenuItem value={'NU'}>Niue</MenuItem>
            <MenuItem value={'NF'}>Norfolk Island</MenuItem>
            <MenuItem value={'MP'}>Northern Mariana Islands</MenuItem>
            <MenuItem value={'NO'}>Norway</MenuItem>
            <MenuItem value={'OM'}>Oman</MenuItem>
            <MenuItem value={'PK'}>Pakistan</MenuItem>
            <MenuItem value={'PW'}>Palau</MenuItem>
            <MenuItem value={'PS'}>Palestine</MenuItem>
            <MenuItem value={'PA'}>Panama</MenuItem>
            <MenuItem value={'PG'}>Papua New Guinea</MenuItem>
            <MenuItem value={'PY'}>Paraguay</MenuItem>
            <MenuItem value={'PE'}>Peru</MenuItem>
            <MenuItem value={'PH'}>Philippines</MenuItem>
            <MenuItem value={'PN'}>Pitcairn</MenuItem>
            <MenuItem value={'PL'}>Poland</MenuItem>
            <MenuItem value={'PT'}>Portugal</MenuItem>
            <MenuItem value={'PR'}>Puerto Rico</MenuItem>
            <MenuItem value={'QA'}>Qatar</MenuItem>
            <MenuItem value={'RE'}>Réunion</MenuItem>
            <MenuItem value={'RO'}>Romania</MenuItem>
            <MenuItem value={'RU'}>Russian Federation</MenuItem>
            <MenuItem value={'RW'}>Rwanda</MenuItem>
            <MenuItem value={'BL'}>Saint Barthélemy</MenuItem>
            <MenuItem value={'SH'}>Saint Helena, Ascension and Tristan da Cunha</MenuItem>
            <MenuItem value={'KN'}>Saint Kitts and Nevis</MenuItem>
            <MenuItem value={'LC'}>Saint Lucia</MenuItem>
            <MenuItem value={'MF'}>Saint Martin</MenuItem>
            <MenuItem value={'PM'}>Saint Pierre and Miquelon</MenuItem>
            <MenuItem value={'VC'}>Saint Vincent and the Grenadines</MenuItem>
            <MenuItem value={'WS'}>Samoa</MenuItem>
            <MenuItem value={'SM'}>San Marino</MenuItem>
            <MenuItem value={'ST'}>Sao Tome and Principe</MenuItem>
            <MenuItem value={'SA'}>Saudi Arabia</MenuItem>
            <MenuItem value={'SN'}>Senegal</MenuItem>
            <MenuItem value={'RS'}>Serbia</MenuItem>
            <MenuItem value={'SC'}>Seychelles</MenuItem>
            <MenuItem value={'SL'}>Sierra Leone</MenuItem>
            <MenuItem value={'SG'}>Singapore</MenuItem>
            <MenuItem value={'SX'}>Sint Maarten</MenuItem>
            <MenuItem value={'SK'}>Slovakia</MenuItem>
            <MenuItem value={'SI'}>Slovenia</MenuItem>
            <MenuItem value={'SB'}>Solomon Islands</MenuItem>
            <MenuItem value={'SO'}>Somalia</MenuItem>
            <MenuItem value={'ZA'}>South Africa</MenuItem>
            <MenuItem value={'GS'}>South Georgia and the South Sandwich Islands</MenuItem>
            <MenuItem value={'SS'}>South Sudan</MenuItem>
            <MenuItem value={'ES'}>Spain</MenuItem>
            <MenuItem value={'LK'}>Sri Lanka</MenuItem>
            <MenuItem value={'SD'}>Sudan</MenuItem>
            <MenuItem value={'SR'}>Suriname</MenuItem>
            <MenuItem value={'SJ'}>Svalbard and Jan Mayen</MenuItem>
            <MenuItem value={'SZ'}>Swaziland</MenuItem>
            <MenuItem value={'SE'}>Sweden</MenuItem>
            <MenuItem value={'CH'}>Switzerland</MenuItem>
            <MenuItem value={'SY'}>Syrian Arab Republic</MenuItem>
            <MenuItem value={'TW'}>Taiwan</MenuItem>
            <MenuItem value={'TJ'}>Tajikistan</MenuItem>
            <MenuItem value={'TZ'}>Tanzania</MenuItem>
            <MenuItem value={'TH'}>Thailand</MenuItem>
            <MenuItem value={'TL'}>Timor-Leste</MenuItem>
            <MenuItem value={'TG'}>Togo</MenuItem>
            <MenuItem value={'TK'}>Tokelau</MenuItem>
            <MenuItem value={'TO'}>Tonga</MenuItem>
            <MenuItem value={'TT'}>Trinidad and Tobago</MenuItem>
            <MenuItem value={'TN'}>Tunisia</MenuItem>
            <MenuItem value={'TR'}>Turkey</MenuItem>
            <MenuItem value={'TM'}>Turkmenistan</MenuItem>
            <MenuItem value={'TC'}>Turks and Caicos Islands</MenuItem>
            <MenuItem value={'TV'}>Tuvalu</MenuItem>
            <MenuItem value={'UG'}>Uganda</MenuItem>
            <MenuItem value={'UA'}>Ukraine</MenuItem>
            <MenuItem value={'AE'}>United Arab Emirates</MenuItem>
            <MenuItem value={'GB'}>United Kingdom</MenuItem>
            <MenuItem value={'US'}>United States</MenuItem>
            <MenuItem value={'UM'}>United States Minor Outlying Islands</MenuItem>
            <MenuItem value={'UY'}>Uruguay</MenuItem>
            <MenuItem value={'UZ'}>Uzbekistan</MenuItem>
            <MenuItem value={'VU'}>Vanuatu</MenuItem>
            <MenuItem value={'VE'}>Venezuela</MenuItem>
            <MenuItem value={'VN'}>Vietnam</MenuItem>
            <MenuItem value={'VG'}>British Virgin Islands</MenuItem>
            <MenuItem value={'VI'}>United States Virgin Islands</MenuItem>
            <MenuItem value={'WF'}>Wallis and Futuna</MenuItem>
            <MenuItem value={'EH'}>Western Sahara</MenuItem>
            <MenuItem value={'YE'}>Yemen</MenuItem>
            <MenuItem value={'ZM'}>Zambia</MenuItem>
            <MenuItem value={'ZW'}>Zimbabwe</MenuItem>
            </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
            <InputLabel required variant="outlined">Banking Country</InputLabel>
            <Select
              required
              disabled={success}
              id="bankingCountry"
              name="bankingCountry"
              label="Banking Country"
              fullWidth
              variant="outlined"
              onChange={(e) => {setBankingCountry(e.target.value); setBankingCountryOptions(options[e.target.value]); setPayoutOption(''); if(!country){setCountry(e.target.value);}}}
              value={bankingCountry}
            >
            <MenuItem value={'AF'}>Afghanistan</MenuItem>
            <MenuItem value={'AX'}>Åland Islands</MenuItem>
            <MenuItem value={'AL'}>Albania</MenuItem>
            <MenuItem value={'DZ'}>Algeria</MenuItem>
            <MenuItem value={'AS'}>American Samoa</MenuItem>
            <MenuItem value={'AD'}>Andorra</MenuItem>
            <MenuItem value={'AO'}>Angola</MenuItem>
            <MenuItem value={'AI'}>Anguilla</MenuItem>
            <MenuItem value={'AQ'}>Antarctica</MenuItem>
            <MenuItem value={'AG'}>Antigua and Barbuda</MenuItem>
            <MenuItem value={'AR'}>Argentina</MenuItem>
            <MenuItem value={'AM'}>Armenia</MenuItem>
            <MenuItem value={'AW'}>Aruba</MenuItem>
            <MenuItem value={'AU'}>Australia</MenuItem>
            <MenuItem value={'AT'}>Austria</MenuItem>
            <MenuItem value={'AZ'}>Azerbaijan</MenuItem>
            <MenuItem value={'BS'}>Bahamas</MenuItem>
            <MenuItem value={'BH'}>Bahrain</MenuItem>
            <MenuItem value={'BD'}>Bangladesh</MenuItem>
            <MenuItem value={'BB'}>Barbados</MenuItem>
            <MenuItem value={'BY'}>Belarus</MenuItem>
            <MenuItem value={'BE'}>Belgium</MenuItem>
            <MenuItem value={'BZ'}>Belize</MenuItem>
            <MenuItem value={'BJ'}>Benin</MenuItem>
            <MenuItem value={'BM'}>Bermuda</MenuItem>
            <MenuItem value={'BT'}>Bhutan</MenuItem>
            <MenuItem value={'BO'}>Bolivia</MenuItem>
            <MenuItem value={'BQ'}>Bonaire</MenuItem>
            <MenuItem value={'BA'}>Bosnia and Herzegovina</MenuItem>
            <MenuItem value={'BW'}>Botswana</MenuItem>
            <MenuItem value={'BV'}>Bouvet Island</MenuItem>
            <MenuItem value={'BR'}>Brazil</MenuItem>
            <MenuItem value={'IO'}>British Indian Ocean Territory</MenuItem>
            <MenuItem value={'BN'}>Brunei</MenuItem>
            <MenuItem value={'BG'}>Bulgaria</MenuItem>
            <MenuItem value={'BF'}>Burkina Faso</MenuItem>
            <MenuItem value={'BI'}>Burundi</MenuItem>
            <MenuItem value={'KH'}>Cambodia</MenuItem>
            <MenuItem value={'CM'}>Cameroon</MenuItem>
            <MenuItem value={'CA'}>Canada</MenuItem>
            <MenuItem value={'CV'}>Cape Verde</MenuItem>
            <MenuItem value={'KY'}>Cayman Islands</MenuItem>
            <MenuItem value={'CF'}>Central African Republic</MenuItem>
            <MenuItem value={'TD'}>Chad</MenuItem>
            <MenuItem value={'CL'}>Chile</MenuItem>
            <MenuItem value={'CN'}>China</MenuItem>
            <MenuItem value={'CX'}>Christmas Island</MenuItem>
            <MenuItem value={'CC'}>Cocos Islands</MenuItem>
            <MenuItem value={'CO'}>Colombia</MenuItem>
            <MenuItem value={'KM'}>Comoros</MenuItem>
            <MenuItem value={'CG'}>Republic of the Congo</MenuItem>
            <MenuItem value={'CD'}>Democratic Republic of the Congo</MenuItem>
            <MenuItem value={'CK'}>Cook Islands</MenuItem>
            <MenuItem value={'CR'}>Costa Rica</MenuItem>
            <MenuItem value={'CI'}>Côte d'Ivoire</MenuItem>
            <MenuItem value={'HR'}>Croatia</MenuItem>
            <MenuItem value={'CU'}>Cuba</MenuItem>
            <MenuItem value={'CW'}>Curaçao</MenuItem>
            <MenuItem value={'CY'}>Cyprus</MenuItem>
            <MenuItem value={'CZ'}>Czech Republic</MenuItem>
            <MenuItem value={'DK'}>Denmark</MenuItem>
            <MenuItem value={'DJ'}>Djibouti</MenuItem>
            <MenuItem value={'DM'}>Dominica</MenuItem>
            <MenuItem value={'DO'}>Dominican Republic</MenuItem>
            <MenuItem value={'EC'}>Ecuador</MenuItem>
            <MenuItem value={'EG'}>Egypt</MenuItem>
            <MenuItem value={'SV'}>El Salvador</MenuItem>
            <MenuItem value={'GQ'}>Equatorial Guinea</MenuItem>
            <MenuItem value={'ER'}>Eritrea</MenuItem>
            <MenuItem value={'EE'}>Estonia</MenuItem>
            <MenuItem value={'ET'}>Ethiopia</MenuItem>
            <MenuItem value={'FK'}>Falkland Islands</MenuItem>
            <MenuItem value={'FO'}>Faroe Islands</MenuItem>
            <MenuItem value={'FJ'}>Fiji</MenuItem>
            <MenuItem value={'FI'}>Finland</MenuItem>
            <MenuItem value={'FR'}>France</MenuItem>
            <MenuItem value={'GF'}>French Guiana</MenuItem>
            <MenuItem value={'PF'}>French Polynesia</MenuItem>
            <MenuItem value={'TF'}>French Southern Territories</MenuItem>
            <MenuItem value={'GA'}>Gabon</MenuItem>
            <MenuItem value={'GM'}>Gambia</MenuItem>
            <MenuItem value={'GE'}>Georgia</MenuItem>
            <MenuItem value={'DE'}>Germany</MenuItem>
            <MenuItem value={'GH'}>Ghana</MenuItem>
            <MenuItem value={'GI'}>Gibraltar</MenuItem>
            <MenuItem value={'GR'}>Greece</MenuItem>
            <MenuItem value={'GL'}>Greenland</MenuItem>
            <MenuItem value={'GD'}>Grenada</MenuItem>
            <MenuItem value={'GP'}>Guadeloupe</MenuItem>
            <MenuItem value={'GU'}>Guam</MenuItem>
            <MenuItem value={'GT'}>Guatemala</MenuItem>
            <MenuItem value={'GG'}>Guernsey</MenuItem>
            <MenuItem value={'GN'}>Guinea</MenuItem>
            <MenuItem value={'GW'}>Guinea-Bissau</MenuItem>
            <MenuItem value={'GY'}>Guyana</MenuItem>
            <MenuItem value={'HT'}>Haiti</MenuItem>
            <MenuItem value={'HM'}>Heard Island and McDonald Islands</MenuItem>
            <MenuItem value={'VA'}>Vatican City</MenuItem>
            <MenuItem value={'HN'}>Honduras</MenuItem>
            <MenuItem value={'HK'}>Hong Kong</MenuItem>
            <MenuItem value={'HU'}>Hungary</MenuItem>
            <MenuItem value={'IS'}>Iceland</MenuItem>
            <MenuItem value={'IN'}>India</MenuItem>
            <MenuItem value={'ID'}>Indonesia</MenuItem>
            <MenuItem value={'IR'}>Iran</MenuItem>
            <MenuItem value={'IQ'}>Iraq</MenuItem>
            <MenuItem value={'IE'}>Ireland</MenuItem>
            <MenuItem value={'IM'}>Isle of Man</MenuItem>
            <MenuItem value={'IL'}>Israel</MenuItem>
            <MenuItem value={'IT'}>Italy</MenuItem>
            <MenuItem value={'JM'}>Jamaica</MenuItem>
            <MenuItem value={'JP'}>Japan</MenuItem>
            <MenuItem value={'JE'}>Jersey</MenuItem>
            <MenuItem value={'JO'}>Jordan</MenuItem>
            <MenuItem value={'KZ'}>Kazakhstan</MenuItem>
            <MenuItem value={'KE'}>Kenya</MenuItem>
            <MenuItem value={'KI'}>Kiribati</MenuItem>
            <MenuItem value={'XK'}>Kosovo</MenuItem>
            <MenuItem value={'KP'}>North Korea</MenuItem>
            <MenuItem value={'KR'}>South Korea</MenuItem>
            <MenuItem value={'KW'}>Kuwait</MenuItem>
            <MenuItem value={'KG'}>Kyrgyzstan</MenuItem>
            <MenuItem value={'LA'}>Laos</MenuItem>
            <MenuItem value={'LV'}>Latvia</MenuItem>
            <MenuItem value={'LB'}>Lebanon</MenuItem>
            <MenuItem value={'LS'}>Lesotho</MenuItem>
            <MenuItem value={'LR'}>Liberia</MenuItem>
            <MenuItem value={'LY'}>Libya</MenuItem>
            <MenuItem value={'LI'}>Liechtenstein</MenuItem>
            <MenuItem value={'LT'}>Lithuania</MenuItem>
            <MenuItem value={'LU'}>Luxembourg</MenuItem>
            <MenuItem value={'MO'}>Macao</MenuItem>
            <MenuItem value={'MK'}>Macedonia</MenuItem>
            <MenuItem value={'MG'}>Madagascar</MenuItem>
            <MenuItem value={'MW'}>Malawi</MenuItem>
            <MenuItem value={'MY'}>Malaysia</MenuItem>
            <MenuItem value={'MV'}>Maldives</MenuItem>
            <MenuItem value={'ML'}>Mali</MenuItem>
            <MenuItem value={'MT'}>Malta</MenuItem>
            <MenuItem value={'MH'}>Marshall Islands</MenuItem>
            <MenuItem value={'MQ'}>Martinique</MenuItem>
            <MenuItem value={'MR'}>Mauritania</MenuItem>
            <MenuItem value={'MU'}>Mauritius</MenuItem>
            <MenuItem value={'YT'}>Mayotte</MenuItem>
            <MenuItem value={'MX'}>Mexico</MenuItem>
            <MenuItem value={'FM'}>Micronesia</MenuItem>
            <MenuItem value={'MD'}>Moldova</MenuItem>
            <MenuItem value={'MC'}>Monaco</MenuItem>
            <MenuItem value={'MN'}>Mongolia</MenuItem>
            <MenuItem value={'ME'}>Montenegro</MenuItem>
            <MenuItem value={'MS'}>Montserrat</MenuItem>
            <MenuItem value={'MA'}>Morocco</MenuItem>
            <MenuItem value={'MZ'}>Mozambique</MenuItem>
            <MenuItem value={'MM'}>Myanmar</MenuItem>
            <MenuItem value={'NA'}>Namibia</MenuItem>
            <MenuItem value={'NR'}>Nauru</MenuItem>
            <MenuItem value={'NP'}>Nepal</MenuItem>
            <MenuItem value={'NL'}>Netherlands</MenuItem>
            <MenuItem value={'AN'}>Netherlands Antilles</MenuItem>
            <MenuItem value={'NC'}>New Caledonia</MenuItem>
            <MenuItem value={'NZ'}>New Zealand</MenuItem>
            <MenuItem value={'NI'}>Nicaragua</MenuItem>
            <MenuItem value={'NE'}>Niger</MenuItem>
            <MenuItem value={'NG'}>Nigeria</MenuItem>
            <MenuItem value={'NU'}>Niue</MenuItem>
            <MenuItem value={'NF'}>Norfolk Island</MenuItem>
            <MenuItem value={'MP'}>Northern Mariana Islands</MenuItem>
            <MenuItem value={'NO'}>Norway</MenuItem>
            <MenuItem value={'OM'}>Oman</MenuItem>
            <MenuItem value={'PK'}>Pakistan</MenuItem>
            <MenuItem value={'PW'}>Palau</MenuItem>
            <MenuItem value={'PS'}>Palestine</MenuItem>
            <MenuItem value={'PA'}>Panama</MenuItem>
            <MenuItem value={'PG'}>Papua New Guinea</MenuItem>
            <MenuItem value={'PY'}>Paraguay</MenuItem>
            <MenuItem value={'PE'}>Peru</MenuItem>
            <MenuItem value={'PH'}>Philippines</MenuItem>
            <MenuItem value={'PN'}>Pitcairn</MenuItem>
            <MenuItem value={'PL'}>Poland</MenuItem>
            <MenuItem value={'PT'}>Portugal</MenuItem>
            <MenuItem value={'PR'}>Puerto Rico</MenuItem>
            <MenuItem value={'QA'}>Qatar</MenuItem>
            <MenuItem value={'RE'}>Réunion</MenuItem>
            <MenuItem value={'RO'}>Romania</MenuItem>
            <MenuItem value={'RU'}>Russian Federation</MenuItem>
            <MenuItem value={'RW'}>Rwanda</MenuItem>
            <MenuItem value={'BL'}>Saint Barthélemy</MenuItem>
            <MenuItem value={'SH'}>Saint Helena, Ascension and Tristan da Cunha</MenuItem>
            <MenuItem value={'KN'}>Saint Kitts and Nevis</MenuItem>
            <MenuItem value={'LC'}>Saint Lucia</MenuItem>
            <MenuItem value={'MF'}>Saint Martin</MenuItem>
            <MenuItem value={'PM'}>Saint Pierre and Miquelon</MenuItem>
            <MenuItem value={'VC'}>Saint Vincent and the Grenadines</MenuItem>
            <MenuItem value={'WS'}>Samoa</MenuItem>
            <MenuItem value={'SM'}>San Marino</MenuItem>
            <MenuItem value={'ST'}>Sao Tome and Principe</MenuItem>
            <MenuItem value={'SA'}>Saudi Arabia</MenuItem>
            <MenuItem value={'SN'}>Senegal</MenuItem>
            <MenuItem value={'RS'}>Serbia</MenuItem>
            <MenuItem value={'SC'}>Seychelles</MenuItem>
            <MenuItem value={'SL'}>Sierra Leone</MenuItem>
            <MenuItem value={'SG'}>Singapore</MenuItem>
            <MenuItem value={'SX'}>Sint Maarten</MenuItem>
            <MenuItem value={'SK'}>Slovakia</MenuItem>
            <MenuItem value={'SI'}>Slovenia</MenuItem>
            <MenuItem value={'SB'}>Solomon Islands</MenuItem>
            <MenuItem value={'SO'}>Somalia</MenuItem>
            <MenuItem value={'ZA'}>South Africa</MenuItem>
            <MenuItem value={'GS'}>South Georgia and the South Sandwich Islands</MenuItem>
            <MenuItem value={'SS'}>South Sudan</MenuItem>
            <MenuItem value={'ES'}>Spain</MenuItem>
            <MenuItem value={'LK'}>Sri Lanka</MenuItem>
            <MenuItem value={'SD'}>Sudan</MenuItem>
            <MenuItem value={'SR'}>Suriname</MenuItem>
            <MenuItem value={'SJ'}>Svalbard and Jan Mayen</MenuItem>
            <MenuItem value={'SZ'}>Swaziland</MenuItem>
            <MenuItem value={'SE'}>Sweden</MenuItem>
            <MenuItem value={'CH'}>Switzerland</MenuItem>
            <MenuItem value={'SY'}>Syrian Arab Republic</MenuItem>
            <MenuItem value={'TW'}>Taiwan</MenuItem>
            <MenuItem value={'TJ'}>Tajikistan</MenuItem>
            <MenuItem value={'TZ'}>Tanzania</MenuItem>
            <MenuItem value={'TH'}>Thailand</MenuItem>
            <MenuItem value={'TL'}>Timor-Leste</MenuItem>
            <MenuItem value={'TG'}>Togo</MenuItem>
            <MenuItem value={'TK'}>Tokelau</MenuItem>
            <MenuItem value={'TO'}>Tonga</MenuItem>
            <MenuItem value={'TT'}>Trinidad and Tobago</MenuItem>
            <MenuItem value={'TN'}>Tunisia</MenuItem>
            <MenuItem value={'TR'}>Turkey</MenuItem>
            <MenuItem value={'TM'}>Turkmenistan</MenuItem>
            <MenuItem value={'TC'}>Turks and Caicos Islands</MenuItem>
            <MenuItem value={'TV'}>Tuvalu</MenuItem>
            <MenuItem value={'UG'}>Uganda</MenuItem>
            <MenuItem value={'UA'}>Ukraine</MenuItem>
            <MenuItem value={'AE'}>United Arab Emirates</MenuItem>
            <MenuItem value={'GB'}>United Kingdom</MenuItem>
            <MenuItem value={'US'}>United States</MenuItem>
            <MenuItem value={'UM'}>United States Minor Outlying Islands</MenuItem>
            <MenuItem value={'UY'}>Uruguay</MenuItem>
            <MenuItem value={'UZ'}>Uzbekistan</MenuItem>
            <MenuItem value={'VU'}>Vanuatu</MenuItem>
            <MenuItem value={'VE'}>Venezuela</MenuItem>
            <MenuItem value={'VN'}>Vietnam</MenuItem>
            <MenuItem value={'VG'}>British Virgin Islands</MenuItem>
            <MenuItem value={'VI'}>United States Virgin Islands</MenuItem>
            <MenuItem value={'WF'}>Wallis and Futuna</MenuItem>
            <MenuItem value={'EH'}>Western Sahara</MenuItem>
            <MenuItem value={'YE'}>Yemen</MenuItem>
            <MenuItem value={'ZM'}>Zambia</MenuItem>
            <MenuItem value={'ZW'}>Zimbabwe</MenuItem>
            </Select>
            </FormControl>
          </Grid>
          {bankingCountryOptions && bankingCountryOptions.length > 0 && (<Grid item xs={12} sm={12}>
            <RadioGroup
              row
              name="radio-buttons-group"
              onChange={handleSelection}
              value={payoutOption}
            >
              {bankingCountryOptions[0] ? <FormControlLabel disabled={success} value="ACH" control={<Radio />} label="ACH (Currency: USD + Fee: $3.00)" /> : null}
              {bankingCountryOptions[1] ? <FormControlLabel disabled={success} value="SEPA" control={<Radio />} label="SEPA (Currency: EUR + Fee: €3.00)" /> : null}
              {bankingCountryOptions[2] ? <FormControlLabel disabled={success} value="SWIFT" control={<Radio />} label="SWIFT (Currency: USD + Fee: $10.00)" /> : null}
              {bankingCountryOptions[3] ? <FormControlLabel disabled={success} value="PAYPAL" control={<Radio />} label="PayPal (Currency: USD + Fee: $3.00)" /> : null}
            </RadioGroup>
            {!bankingCountryOptions[0] && !bankingCountryOptions[1] && !bankingCountryOptions[2] && !bankingCountryOptions[3] ? "We currently do not support payouts to the selected banking country." : null}
            {bankingCountryOptions[0] || bankingCountryOptions[1] || bankingCountryOptions[2] || bankingCountryOptions[3] ? "Payouts are sent NET 30 from the confirmation date. Revenue under $100.00 is accumulated. By selecting a payout method you are agreeing to our\u00A0" : null}
            {bankingCountryOptions[0] || bankingCountryOptions[1] || bankingCountryOptions[2] || bankingCountryOptions[3] ? <a href="https://make-money.top/mw/Publisher_Agreement.pdf" target="_blank">Publisher Agreement.</a> : null}
          </Grid>)}
          {payoutOption === "ACH" && (<><Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="accountHolder"
              name="accountHolder"
              label="Account Holder"
              fullWidth
              variant="outlined"
              error={accountHolderErrorMessage ? true : false}
              helperText={accountHolderErrorMessage}
              onChange={(e) => {setAccountHolder(e.target.value); setAccountHolderErrorMessage('');}}
              value={accountHolder}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="bankName"
              name="bankName"
              label="Bank Name"
              fullWidth
              variant="outlined"
              error={bankNameErrorMessage ? true : false}
              helperText={bankNameErrorMessage}
              onChange={(e) => {setBankName(e.target.value); setBankNameErrorMessage('');}}
              value={bankName}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="bankNumber"
              name="bankNumber"
              label="Routing Number"
              fullWidth
              variant="outlined"
              error={bankNumberErrorMessage ? true : false}
              helperText={bankNumberErrorMessage}
              onChange={(e) => {setBankNumber(e.target.value); setBankNumberErrorMessage('');}}
              value={bankNumber}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="accountNumber"
              name="accountNumber"
              label="Account Number"
              fullWidth
              variant="outlined"
              error={accountNumberErrorMessage ? true : false}
              helperText={accountNumberErrorMessage}
              onChange={(e) => {setAccountNumber(e.target.value); setAccountNumberErrorMessage('');}}
              value={accountNumber}
            />
          </Grid></>)}
          {payoutOption === "SWIFT" && (<><Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="accountHolder"
              name="accountHolder"
              label="Account Holder"
              fullWidth
              variant="outlined"
              error={accountHolderErrorMessage ? true : false}
              helperText={accountHolderErrorMessage}
              onChange={(e) => {setAccountHolder(e.target.value); setAccountHolderErrorMessage('');}}
              value={accountHolder}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="bankName"
              name="bankName"
              label="Bank Name"
              fullWidth
              variant="outlined"
              error={bankNameErrorMessage ? true : false}
              helperText={bankNameErrorMessage}
              onChange={(e) => {setBankName(e.target.value); setBankNameErrorMessage('');}}
              value={bankName}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="bankNumber"
              name="bankNumber"
              label="SWIFT"
              fullWidth
              variant="outlined"
              error={bankNumberErrorMessage ? true : false}
              helperText={bankNumberErrorMessage}
              onChange={(e) => {setBankNumber(e.target.value); setBankNumberErrorMessage('');}}
              value={bankNumber}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="accountNumber"
              name="accountNumber"
              label="Account Number"
              fullWidth
              variant="outlined"
              error={accountNumberErrorMessage ? true : false}
              helperText={accountNumberErrorMessage}
              onChange={(e) => {setAccountNumber(e.target.value); setAccountNumberErrorMessage('');}}
              value={accountNumber}
            />
          </Grid></>)}
          {payoutOption === "SEPA" && (<><Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="accountHolder"
              name="accountHolder"
              label="Account Holder"
              fullWidth
              variant="outlined"
              error={accountHolderErrorMessage ? true : false}
              helperText={accountHolderErrorMessage}
              onChange={(e) => {setAccountHolder(e.target.value); setAccountHolderErrorMessage('');}}
              value={accountHolder}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="bankName"
              name="bankName"
              label="Bank Name"
              fullWidth
              variant="outlined"
              error={bankNameErrorMessage ? true : false}
              helperText={bankNameErrorMessage}
              onChange={(e) => {setBankName(e.target.value); setBankNameErrorMessage('');}}
              value={bankName}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="bankNumber"
              name="bankNumber"
              label="BIC"
              fullWidth
              variant="outlined"
              error={bankNumberErrorMessage ? true : false}
              helperText={bankNumberErrorMessage}
              onChange={(e) => {setBankNumber(e.target.value); setBankNumberErrorMessage('');}}
              value={bankNumber}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              disabled={success}
              id="accountNumber"
              name="accountNumber"
              label="IBAN"
              fullWidth
              variant="outlined"
              error={accountNumberErrorMessage ? true : false}
              helperText={accountNumberErrorMessage}
              onChange={(e) => {setAccountNumber(e.target.value); setAccountNumberErrorMessage('');}}
              value={accountNumber}
            />
          </Grid></>)}
          {payoutOption === "PAYPAL" && (<Grid item xs={12} sm={12}>
            <TextField
              required
              disabled={success}
              id="paypalEmail"
              name="paypalEmail"
              label="PayPal Email Address"
              fullWidth
              variant="outlined"
              error={paypalEmailErrorMessage ? true : false}
              helperText={paypalEmailErrorMessage}
              onChange={(e) => {setPaypalEmail(e.target.value); setPaypalEmailErrorMessage('');}}
              value={paypalEmail}
            />
          </Grid>)}
          {payoutOption && !success && (<Grid item xs={12} sm={12}>
            <LoadingButton loading={loading} variant="contained" size="large" onClick={async () => {
              var ready = true;
              if(!firstName) {
                setFirstNameErrorMessage('Cannot be empty');
                ready = false;
              }
              if(!lastName) {
                setLastNameErrorMessage('Cannot be empty');
                ready = false;
              }
              if(!address) {
                setAddressErrorMessage('Cannot be empty');
                ready = false;
              }
              if(!city) {
                setCityErrorMessage('Cannot be empty');
                ready = false;
              }
              if(!zip) {
                setZipErrorMessage('Cannot be empty');
                ready = false;
              }
              if(!accountHolder && payoutOption !== 'PAYPAL') {
                setAccountHolderErrorMessage('Cannot be empty');
                ready = false;
              }
              if(!bankName && payoutOption !== 'PAYPAL') {
                setBankNameErrorMessage('Cannot be empty');
                ready = false;
              }
              if(!bankNumber && payoutOption !== 'PAYPAL') {
                setBankNumberErrorMessage('Cannot be empty');
                ready = false;
              }
              if(!accountNumber && payoutOption !== 'PAYPAL') {
                setAccountNumberErrorMessage('Cannot be empty');
                ready = false;
              }
              if(!paypalEmail && payoutOption === 'PAYPAL') {
                setPaypalEmailErrorMessage('Cannot be empty');
                ready = false;
              } else if ((!(String(paypalEmail).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/))) && payoutOption === 'PAYPAL') {
                setPaypalEmailErrorMessage('Must be a valid email address');
                ready = false;
              }
              if(ready) {
                if(!(localStorage.getItem("mmEmail") && localStorage.getItem("mmSecret"))) {
                  navigate('/login', { replace: true });
                }
                setLoading(true);
                var response = await fetch('https://data.make-money.top/dashboard/p?hash=' + hashCode(localStorage.getItem("mmEmail")), {
                  method: 'POST',
                  body: JSON.stringify({
                    email: localStorage.getItem("mmEmail"),
                    secret: localStorage.getItem("mmSecret"),
                    firstName,
                    lastName,
                    company,
                    address,
                    city,
                    zip,
                    province,
                    country,
                    bankingCountry,
                    payoutOption,
                    accountHolder,
                    bankName,
                    bankNumber,
                    accountNumber,
                    paypalEmail
                  }),
                });
                if (response.ok) {
                  setLoading(false);
                  setSuccess(true);
                } else {
                  alert('Please try again.')
                }
              }
            }}>
           Save
         </LoadingButton></Grid>)}
         {success && <Grid item xs={12} sm={12}>
           <Button variant="contained" size="large" color="success" onClick={async () => {navigate('/dashboard', { replace: true });}}>
         Success</Button></Grid>}
        </Grid>
        </Card>
        </Container>
        <Loading loading={isLoading} loaderColor="#3498db" />
      </>
  );
}
